module.exports = __webpack_public_path__ + "img/pdf2.a8bdbaa8.png";